import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-white" data-id="element-61">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-success-light/30 rounded-3xl p-8 md:p-12 border border-success-light text-center relative overflow-hidden" data-id="element-63">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-success/10 rounded-full blur-3xl" data-id="element-64"></div>

          <div className="relative z-10" data-id="element-65">
            <div className="w-20 h-20 mx-auto bg-success text-white rounded-full flex items-center justify-center shadow-lg shadow-success/30 mb-6" data-id="element-66">
              <ShieldCheck className="w-10 h-10" data-id="element-67" />
            </div>

            <div className="inline-block text-success font-bold text-sm uppercase tracking-wider mb-2" data-id="element-68">
              Compra protegida
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6" data-id="element-69">
              Garantía de satisfacción de 7 días
            </h2>

            <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-70">
              Descargá el MegaPack, revisalo, usalo en tu sala. Si en los
              próximos 7 días sentís que no es lo que esperabas, escribinos y te
              devolvemos el 100% de tu dinero.
            </p>

            <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-71">
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full text-sm font-bold text-gray-800 shadow-sm border border-gray-100" data-id="element-72">
                <Check className="w-4 h-4 text-success" data-id="element-73" /> Sin preguntas
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full text-sm font-bold text-gray-800 shadow-sm border border-gray-100" data-id="element-74">
                <Check className="w-4 h-4 text-success" data-id="element-75" /> Sin vueltas
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full text-sm font-bold text-gray-800 shadow-sm border border-gray-100" data-id="element-76">
                <Check className="w-4 h-4 text-success" data-id="element-77" /> Sin letra chica
              </div>
            </div>

            <div className="bg-white/60 rounded-xl p-6 backdrop-blur-sm" data-id="element-78">
              <p className="font-black text-gray-900 text-xl mb-2" data-id="element-79">
                El riesgo es nuestro, no tuyo.
              </p>
              <p className="text-gray-600 text-sm" data-id="element-80">
                La confianza que tenemos en el MegaPack Psicopedagogía nos
                permite hacer esa promesa sin dudar. Más de 300 profesionales de
                todo el país ya lo saben. La tasa de devoluciones es menor al
                1%.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}